import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './prioritize-impact-analysis-dialog.controller';
import template from './prioritize-impact-analysis-dialog.html';


class dialogService {
  getOptions($event, { processes }) {
    return {
      controller,
      controllerAs: 'prioritizeImpactAnalysisDialogVM',
      locals: {
        processes
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.prioritizeImpactAnalysisDialog', [
  alerts,
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('prioritizeImpactAnalysisDialog', dialogService)
  .name;
